import DOMPurify from 'dompurify'

if (!window.gmxDOMPurify) {
	window.gmxDOMPurify = DOMPurify

	// Because this can be loaded asynchronously, we want to dispatch an event when the singleton is ready so that components can listen for it
	window.dispatchEvent(new CustomEvent('gmxDOMPurifyReady'))
}

const gmxDOMPurify = window.gmxDOMPurify
export default gmxDOMPurify
